"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RICH_TEXT_EDITOR_TOOLBAR = exports.RICH_TEXT_EDITOR_REMOVE_BUTTONS = exports.RICH_TEXT_EDITOR_PLUGINS = void 0;
var RICH_TEXT_EDITOR_REMOVE_BUTTONS = ["Underline", "Strike", "Subscript", "Superscript", "Anchor", "Styles", "Specialchar", "Blockquote", "Table", "SpecialChar", "Font"];
exports.RICH_TEXT_EDITOR_REMOVE_BUTTONS = RICH_TEXT_EDITOR_REMOVE_BUTTONS;
var RICH_TEXT_EDITOR_PLUGINS = ["font", "colorbutton", "colordialog"];
exports.RICH_TEXT_EDITOR_PLUGINS = RICH_TEXT_EDITOR_PLUGINS;
var RICH_TEXT_EDITOR_TOOLBAR = [{
  "name": "basicstyles",
  "groups": ["basicstyles"]
}, {
  "name": "links",
  "groups": ["links"]
}, {
  "name": "paragraph",
  "groups": ["list", "blocks"]
}, {
  "name": "insert",
  "groups": ["insert"]
}, {
  "name": "styles",
  "groups": ["styles"]
}, {
  "name": "tools",
  "groups": ["Maximize"]
}, {
  "name": "colors",
  "groups": ["colors"]
}];
exports.RICH_TEXT_EDITOR_TOOLBAR = RICH_TEXT_EDITOR_TOOLBAR;